<template>
    <v-list-item component="AdminMenuListItem">
        <div class="admin-navigation toggleDropdown" v-if="item.children" @click="toggleDropdown = !toggleDropdown">
            <span>{{ item.name }}</span>

            <v-icon v-if="toggleDropdown" class="ml-auto">expand_more</v-icon>
            <v-icon v-else class="ml-auto">expand_less</v-icon>
        </div>

        <router-link class="admin-navigation" v-else :to="{ name: item.path_name }">
            {{ item.name }}
        </router-link>

        <transition name="slide-fade">
            <v-list v-if="item.children && toggleDropdown" class="dropdown-menu">
                <admin-menu-list-item
                    v-for="(child, index) in item.children"
                    :item="child"
                    :key="`admin-menu-child-item-${index}`"
                    class="pr-0"
                />
            </v-list>
        </transition>
    </v-list-item>
</template>

<script>
export default {
    name: 'AdminMenuListItem',

    props: {
        item: {
            name: null,
            path_name: null,
        },
    },

    data() {
        return {
            toggleDropdown: false,
        };
    },

    mounted() {
        if (this.$route.meta.openContractDropdown) {
            this.toggleDropdown = this.$route.meta.openContractDropdown;
        }
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.2s ease-in-out;
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-5px);
    box-shadow: none;
    opacity: 0;
}

.v-list {
    background: transparent;
}

[component='AdminMenuListItem'] {
    .v-list-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-height: auto;
    }

    .toggleDropdown {
        cursor: pointer;
    }

    .admin-navigation {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #555;
        padding: 0px 10px;
        height: 50px;
        font-size: 17px;
        font-weight: 900;
        letter-spacing: 0.04em;
        transition: 0.3s;
        background: transparent;
        border-radius: 0px;
        border-style: solid;
        border-color: transparent transparent #fff transparent;
        border-width: 1px;
    }

    .dropdown-menu {
        width: 100%;
        margin-left: 1rem !important;
        padding: 0;
    }
}
</style>
